import "./EventsList.css";
import React from "react";
import { WP_Event, WP_EventsArray } from "../../model/models";

interface EventsProps {
  events: WP_EventsArray;
  baseUrl: string;
  itemRenderer: (event: WP_Event, baseUrl: string, key: number) => JSX.Element;
}

export const EventsList: React.FC<EventsProps> = ({ events, baseUrl, itemRenderer }) => (
  <ul className="ion-list-events lg:grid lg:grid-cols-2 lg:gap-8 lg:w-full">
    {
      events.map((event, index) => itemRenderer(event, baseUrl, index))
    }
  </ul>
);

export default EventsList;
